/** A style attribute's declarations ("--accent:#123;color:red") as a React style object. */
export function styleDeclarations(text: string | undefined): Record<string, string> | undefined {
  if (!text) return undefined;
  const style: Record<string, string> = {};
  for (const declaration of text.split(";")) {
    const colon = declaration.indexOf(":");
    if (colon < 1) continue;
    const name = declaration.slice(0, colon).trim();
    const value = declaration.slice(colon + 1).trim();
    if (!value) continue;
    // Custom properties keep their names; React expects other properties in camel case.
    style[
      name.startsWith("--") ? name : name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
    ] = value;
  }
  return style;
}
